import { axiosSwagger } from "@/axios";



export const state = {
    // Get All DocumentCategories
    category: {
        loading: false,
        data: [],
        total: 0,
    },
    // Get DocumentCategories by DocumentCategoryGroupId
    categoryByGroup: {
        loading: false,
        data: [],
        total: 0,
    }
}


export const getters = {
}


export const mutations = {
    // CATEGORY
    categoryLoading: (state, loading) => {
        state.category.loading = loading;
    },
    setCategoryData: (state, data) => {
        state.category.data = data;
    },
    setCategoryTotal: (state, total) => {
        state.category.total = total;
    },
    addCategory: (state, data) => {
        state.category.data.push(data);
    },
    removeCategory: (state, id) => {
        state.category.data = state.category.data.filter((el) => el.id !== id);
    },
    updateCategory: (state, data) => {
        const index = state.category.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            // not working i dunno why so manual it is ..
            // state.category.data[index] = data;

            state.category.data[index].category = data.category;
            state.category.data[index].description = data.description;
            state.category.data[index].retention = data.retention;
            state.category.data[index].reference = data.reference;
        }
    },
    // CATEGORY BY GROUP
    categoryGroupLoading: (state, loading) => {
        state.categoryByGroup.loading = loading;
    },
    setCategoryGroupData: (state, data) => {
        state.categoryByGroup.data = data;
    },
    setCategoryGroupTotal: (state, total) => {
        state.categoryByGroup.total = total;
    },
    addCategoryGroup: (state, data) => {
        state.categoryByGroup.data.push(data);
    },
    removeCategoryGroup: (state, id) => {
        state.categoryByGroup.data = state.categoryByGroup.data.filter((el) => el.id !== id);
    },
    updateCategoryGroup: (state, data) => {
        const index = state.categoryByGroup.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            // not working i dunno why so manual it is ..
            // state.category.data[index] = data;

            state.categoryByGroup.data[index].category = data.category;
            state.categoryByGroup.data[index].description = data.description;
            state.categoryByGroup.data[index].retention = data.retention;
            state.categoryByGroup.data[index].reference = data.reference;
        }
    },
}


export const actions = {
    // CATEGORY
    // eslint-disable-next-line no-unused-vars
    async readCategoryById({ commit }, id){
        return await axiosSwagger
            .get(`/api/DocumentCategory/${id}`)
            .then((response) => {

                return response;
            });
    },
    async readCategory({ commit }) {
        commit("categoryLoading", true);

        return await axiosSwagger
        .get("/api/DocumentCategory/All")
        .then((response) => {
            commit("setCategoryData", response.data);
            commit("setCategoryTotal", response.data.length);
            commit("categoryLoading", false);

            return response;
        })
        .catch(() => {
            commit("categoryLoading", false);
        });
    },
    // CATEGORY BY GROUP
    async readCategoryByGroupId({ commit }, id){
        commit("categoryGroupLoading", true);

        return await axiosSwagger
            .get(`/api/DocumentCategory/DocumentCategoryGroup/${id}`)
            .then((response) => {
                commit("setCategoryGroupData", response.data);
                commit("setCategoryGroupTotal", response.data.length);
                commit("categoryGroupLoading", false);

                return response;
            })
            .catch(() => {
                commit("categoryGroupLoading", false);
            });
    },
    async createCategory({ commit }, data) {
        return await axiosSwagger
        .post("/api/DocumentCategory/Create", data)
        .then((response) => {
            commit("addCategoryGroup", response.data);

            return response;
        });
    },
    async deleteCategory({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/DocumentCategory/${id}`)
        .then((response) => {
            commit("removeCategoryGroup", id);

            return response;
        });
    },
    async updateCategory({ commit }, data) {
        return await axiosSwagger
        .put(`/api/DocumentCategory/${data.id}`, data)
        .then((response) => {
            commit("updateCategoryGroup", response.data);

            return response;
        });
    },
    async updateMoveGroupCategory({ commit }, data) {
        return await axiosSwagger
        .put(`/api/DocumentCategory/${data.id}`, data)
        .then((response) => {
            commit("updateCategoryGroup", response.data);
            commit("removeCategoryGroup", data.id);

            return response;
        });
    },
}




// modify data for category data
// const modifyCategoryData = (arrayData) => {
//     if(arrayData?.length ?? false){
//         const groupCategory = [];

//         arrayData.forEach(e => {
            
//             if(!groupCategory.includes(e.reference) && e.reference !== null){
//                 groupCategory.push(e.reference);
//             }

//         });
  
//         return groupCategory;
//     }
  
//     return [];
// };


// modify custom data for category with group data
// const modifyCustomCategoryGroupData = (arrayData) => {
//     if(arrayData?.length ?? false){

//         const groupCategories = arrayData.reduce((result, category) => {
//             const reference = category.reference;
            
//             // Check if the genre exists in the result array, and if not, create it
//             const existingGroup = result.find((group) => group.reference === reference);
//             if (!existingGroup) {
//                 result.push({ reference, categories: [] });
//             }
            
//             // Push the book into the corresponding genre group
//             result.find((group) => group.reference === reference).categories.push(category);
          
          
//             return result;
//         }, []);
  
//         return groupCategories;
//     }
  
//     return [];
// };
